import { getRequest } from './api';

const locationsApi = {
  async fetchCountries(force = false) {
    const response = await getRequest('/locations/countries', { force });
    return response.data;
  },
};

export default locationsApi;